import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import {Header, Footer } from './components/partials';
import { Home, Formulario } from './pages';

import store from './store'
import './App.css'

const App = () => (
  <Provider store={store}>
    <Header />
    <BrowserRouter basename={process.env.REACT_APP_ROUTE_BASENAME}>
      <Switch>
        <Route path="/licenca" component={Formulario} />
        <Route component={Home} />
      </Switch>
    </ BrowserRouter>
    <Footer />
  </Provider>
);

export default App;
